import React from 'react';


const SuccessIconTick = () => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.9795 11.9976C21.9795 17.5094 17.5113 21.9776 11.9995 21.9776C6.48773 21.9776 2.01953 17.5094 2.01953 11.9976C2.01953 6.48578 6.48773 2.01758 11.9995 2.01758C17.5113 2.01758 21.9795 6.48578 21.9795 11.9976ZM6.93042 11.8259C7.21159 11.5447 7.66747 11.5447 7.94865 11.8259L10.2033 14.0806L15.913 8.37096C16.1941 8.08978 16.65 8.08978 16.9312 8.37096C17.2124 8.65214 17.2124 9.10802 16.9312 9.38919L10.7124 15.6079C10.4313 15.8891 9.97539 15.8891 9.69422 15.6079L6.93042 12.8441C6.64924 12.563 6.64924 12.1071 6.93042 11.8259Z" fill="#333333"/>
        <mask id="mask0_1500_25301" maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.9795 11.9976C21.9795 17.5094 17.5113 21.9776 11.9995 21.9776C6.48773 21.9776 2.01953 17.5094 2.01953 11.9976C2.01953 6.48578 6.48773 2.01758 11.9995 2.01758C17.5113 2.01758 21.9795 6.48578 21.9795 11.9976ZM6.93042 11.8259C7.21159 11.5447 7.66747 11.5447 7.94865 11.8259L10.2033 14.0806L15.913 8.37096C16.1941 8.08978 16.65 8.08978 16.9312 8.37096C17.2124 8.65214 17.2124 9.10802 16.9312 9.38919L10.7124 15.6079C10.4313 15.8891 9.97539 15.8891 9.69422 15.6079L6.93042 12.8441C6.64924 12.563 6.64924 12.1071 6.93042 11.8259Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_1500_25301)">
        <rect width="24" height="24" fill="#428600"/>
        </g>
    </svg>
    
  );
}

export default SuccessIconTick